import { useState } from "react";
import { Modal as ModalMantine, useMantineTheme } from "@mantine/core";
import TypeRecover from "./OneStepRecover";
import SendRecover from "./SendRecover";
import PinCode from "./PinCode";
import ChangePassword from "./ChangePassword";
import { Modal } from "../../../components";
import { useUserIP } from "../../../hooks/useAuthService";
import { useTranslation } from "react-i18next";

interface IProps {
  openRecoverPassword: boolean;
  setOpenRecoverPassword: React.Dispatch<React.SetStateAction<boolean>>;
}

const RecoverPassword = ({
  openRecoverPassword,
  setOpenRecoverPassword,
}: IProps) => {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [type, setType] = useState<string>("email");
  const [alreadyPassword, setAlreadyPassword] = useState<boolean>(false);
  const [emailHash, setEmailHash] = useState<string>("");
  const [secretPhrase, setSecretPhrase] = useState<string>("");
  const [stepModal, setStepModal] = useState<number>(1);
  const {
    data: dataIp,
    // isError: isErrorIp
  } = useUserIP();
  const userIp = !!dataIp?.data.ip ? dataIp?.data.ip : "";

  const nextStep = () =>
    setStepModal((current) => (current < 5 ? current + 1 : current));

  const destroyStep = () => {
    setStepModal(0);
    setOpenRecoverPassword(false);
    setOpenModal(false);
  };

  const returnStep = () => {
    setStepModal(stepModal - 1);
  };

  // useEffect(() => {
  //   if (isErrorIp) {
  //     setOpenModal(true);
  //   }
  // }, []);

  return (
    <>
      {/* {!isErrorIp ? ( */}
      <Modal
        type={"success"}
        titleSeccondButton={t("autenticacao.acessar_conta.title")}
        description={t(
          "autenticacao.acessar_conta.forget_password.modal_success.description"
        )}
        open={openModal}
        setClose={destroyStep}
        secondClick={destroyStep}
      />
      {/*) : null} */}

      <ModalMantine
        opened={openRecoverPassword}
        onClose={destroyStep}
        title={
          stepModal < 4
            ? t("autenticacao.acessar_conta.forget_password.title")
            : t("autenticacao.acessar_conta.forget_password.title")
        }
        zIndex={1000}
        centered
        size="auto"
        transitionProps={{
          transition: "slide-up",
          duration: 300,
          timingFunction: "linear",
          exitDuration: 0,
        }}
        styles={{
          content: {
            borderRadius: "12px",
            boxShadow: "0px 25px 35px rgba(0, 0, 0, 0.03);",
          },
          header: {
            padding: "24px 48px",
          },
          inner: {
            background: "rgba(0, 0, 0, 0.6)",
          },
          title: {
            fontSize: "24px",
            fontWeight: 600,
            width: "100%",
            textAlign: "center",
          },
          body: {
            padding: "24px",
            color: theme.colors.basic[5],
          },
          close: {
            position: "absolute",
            top: 12,
            right: 12,
            height: 40,
            width: 40,
            svg: {
              width: 24,
              height: 24,
            },
          },
        }}
      >
        {/* {isErrorIp ? (
          <Modal
            type={"warning"}
            titleSeccondButton="Fechar"
            description="Erro ao obter o endereço IP. Entre em contato com Suporte."
            open={openModal}
            setClose={destroyStep}
            firstClick={() => {}}
            secondClick={destroyStep}
          />
        ) : null} */}
        {stepModal === 1 && (
          <TypeRecover setType={setType} nextStep={nextStep} />
        )}
        {stepModal === 2 && (
          <SendRecover
            nextStep={nextStep}
            type={type}
            setAlreadyPassword={setAlreadyPassword}
            setEmailHash={setEmailHash}
            userIp={userIp}
          />
        )}
        {stepModal === 3 && (
          <PinCode
            setEmailHash={setEmailHash}
            returnStep={returnStep}
            nextStep={nextStep}
            type={type}
            emailHash={emailHash}
            alreadyPassword={alreadyPassword}
            userIp={userIp}
            setSecretPhrase={setSecretPhrase}
          />
        )}
        {stepModal === 4 && (
          <ChangePassword
            secretPhrase={secretPhrase}
            emailHash={emailHash}
            userIp={userIp}
            setOpenModal={setOpenModal}
          />
        )}
      </ModalMantine>
    </>
  );
};

export default RecoverPassword;
